<ng-container>
    <div class="reports-container">
        <mat-drawer-container autosize>
            <div>
                <button type="button" mat-button class="mat-button-panel" *ngIf="!showPanel"
                    (click)="drawer.toggle();leftPanel(showPanel);">
                    <i class="material-symbols-outlined icon-decoration">left_panel_open</i>
                </button>
            </div>
            <div>
                <button type="button" mat-button class="mat-button-panel" *ngIf="!showPanel">
                    <i class="material-symbols-outlined icon-chart-decoration">signal_cellular_alt</i>
                </button>
            </div>
            <mat-drawer #drawer mode="side" [opened]="showPanel" id="mdc">
                <div class="divTable">
                    <div class="divRow">
                        <div class="divCell icon-decoration">
                            <i class="material-symbols-outlined icon-chart-decoration">signal_cellular_alt</i>
                        </div>
                        <div class="divCell">
                            <span class="reports">{{reportMainHeader}}</span>
                        </div>
                        <div class="divCellIcon">
                            <button type="button" class="mat-button-update" mat-button *ngIf="showPanel"
                                (click)="drawer.toggle();leftPanel(showPanel);">
                                <i class="material-symbols-outlined icon-decoration">left_panel_close</i>
                            </button>
                        </div>
                    </div>
                    <ng-container *ngFor="let reportMenu of reportMenus">
                        <mat-expansion-panel class="mat-expansion-panel-update" [expanded]="true">
                            <mat-expansion-panel-header class="mat-expansion-panel-header-update">
                              <mat-panel-title class="mat-panel-title-update" 
                              [ngClass]="{active:this.restSharedService.activeLink == reportMenu.ReportCode}">
                                {{reportMenu.ReportName}}
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div *ngFor="let subMenu of reportMenu.ReportSubMenus" class="reports-items-background">
                                <a href="" class="anchor-decoration" (click)="reportClicked(subMenu.ReportCode,subMenu.ReportId, subMenu.ReportName, reportMenu.ReportCode);">
                                    <span class="reports-items" 
                                    [ngClass]="{active:this.reportId == subMenu.ReportId && this.restSharedService.activeLink == reportMenu.ReportCode}">
                                    {{subMenu.ReportName}}
                                    </span></a>
                            </div>
                        </mat-expansion-panel>
                    </ng-container>
                </div>
            </mat-drawer>
        </mat-drawer-container>
    </div>
</ng-container>